import { createAction } from 'typesafe-actions';

import { Filters } from 'shared/types/filters';

export const setInitialFilters = createAction('filters/setInitialFilters')<Partial<Filters>>();
